import { createReducer, on } from '@ngrx/store';
import { NOTIFICATION_CLEAR, NOTIFICATION_SHOW, CORE_UPDATE_SLUG, CORE_CHANGE_LANGUAJE, CORE_UPDATE_LOADING } from '../actions';
import { INotificationMessage } from '@core/interfaces';
import { LanguajeEnum } from '@core/enums';

export interface CoreState {
  notification: INotificationMessage | null;
  slug: string | null;
  accountSlug: string | null;
  languaje: LanguajeEnum;
  loading: boolean;
}

export const initialState: CoreState = {
  notification: null,
  slug: null,
  accountSlug: null,
  languaje: LanguajeEnum.en,
  loading: false
}

export const coreReducer = createReducer(
  initialState,

  on(NOTIFICATION_SHOW, (state, { notification }) => ({ ...state, notification })),
  on(CORE_UPDATE_SLUG, (state, { slug, accountSlug }) => ({ ...state, slug, accountSlug })),
  on(NOTIFICATION_CLEAR, (state) => ({ ...state, notification: initialState.notification })),
  on(CORE_CHANGE_LANGUAJE, (state, { languaje }) => ({ ...state, languaje })),
  on(CORE_UPDATE_LOADING, (state, { loading }) => ({ ...state, loading })),
);
